export const environment = {
  production: true,
  api: {
    url: 'https://test-chat-backend.qira.net',
    version: '1',
  },
  defaultLang: 'de',
  availableLanguages: ['de'],
  enableEventTracking: true,
  GTM_ID: '',
  HOTJAR_ID: null,
  HOTJAR_VERSION: 6,
  SENTRY_DSN: null,
  PRO_POINTS_REGISTRATION: 'https://propoints-staging.ahead.group/de/en/auth/qira/signups/new',
  environmentName: 'test-chat',
  stripeApiKey: 'pk_test_51Qtni2GWA7Ygu2V4yXPFgIVUVWteKDj8ixqA9ZNKcJRnpOljiT1FVPLzOrLeKQrm1AMrpoPSbzuXMeZVrmV42tT600py00TjS4',
  stripePricingTableId: 'prctbl_1REAMGGWA7Ygu2V4fv30z1AM',
  qira_contact_url: 'https://qira.net/contact',
};
